import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import {setDeliveryMethod} from '../../../actions/reservation';
import {setDeliveryPhone, setDeliveryAddress, setDeliveryCountryCode} from '../actions/delivery';
import {feesSlice} from '../../../slices/fees';

import Delivery from '../components/Delivery';
import ContainerProps from './DeliveryContainerComponent';
import { getInsuranceQuote } from 'checkout/views/insurance/actions/insurance';
import { isKioskMode, getKioskOptions } from '../../../selectors/ui';
import { getAvailableDeliveryOptions } from '../../../selectors/delivery';
import { initKeyboard } from '../../../actions/keyboard';
import { setEmail } from '../../member/actions/member';
import {getDefaultAddress} from "../../../selectors/member";
import {GATEWAY_TYPE_STRIPE} from "../../../reducers/payment";
import { createLoadingSelector } from '@b/checkout/selectors/helpers';

class DeliveryContainer extends Component<ContainerProps> {
    render() {
        if (!this.props.deliveryOptions.length) {
            return null;
        }

        const singularDeliveryOption = this.props.isKioskMode ? this.props.deliveryOptions.length === 1 && !this.props.kioskPrintsTickets : this.props.deliveryOptions.length === 1;

        return(
            <Delivery
                deliveryOptions={this.props.deliveryOptions}
                onDeliveryChange={this.deliveryChange}
                onDeliveryPhoneChange={this.deliveryPhoneChange}
                onCountryCodeChange={this.onCountryCodeChange}
                onPhoneClear={this.onPhoneClear}
                selectedOption={this.props.selectedOption}
                phone={this.props.deliveryPhone}
                countryCode={this.props.countryCode}
                address={this.props.address}
                onAddressChange={this.onAddressChange}
                isKioskMode={this.props.isKioskMode}
                kioskCollectCustomerEmail={this.props.kioskCollectCustomerEmail}
                onEmailChange={this.onEmailChange}
                email={this.props.email}
                onMobileFocus={this.onMobileFocus}
                onEmailFocus={this.onEmailFocus}
                singularDeliveryOption={singularDeliveryOption}
                gatewayType={this.props.gatewayType}
                loading={this.props.loading}
            />
        )
    }

    onMobileFocus = (e, label) => {
        this.props.initKeyboard(e.target, label, setDeliveryPhone, "number");
    }

    onEmailFocus = (e, label) => {
        this.props.initKeyboard(e.target, label, setEmail, "email");
    }

    deliveryChange = (option) => {
        this.props.setDeliveryMethod(option);
        this.props.getInsuranceQuote();

        if (option.method_name === "Mobile") {
            this.props.setDeliveryPhone(this.props.deliveryPhone);
        }

        if(option.method_name === 'Mail' && +this.props.gatewayType === GATEWAY_TYPE_STRIPE) {
            this.props.setDeliveryAddress(false);
        }
    }

    deliveryPhoneChange = (number) => {
        this.props.setDeliveryPhone(number);
    };

    onCountryCodeChange = (code) => {
        this.props.setDeliveryCountryCode(code);
    }

    onPhoneClear = (e) => {
        e.preventDefault();
        this.props.setDeliveryPhone('');
    };

    onAddressChange = (address) => {
      if(!this.props.hasAddress) {
        for (const key in this.props.address) {
          if(this.props.address[key] !== "" && address[key] === "") {
            address[key] = this.props.address[key];
          }
        }
      }

      this.props.setDeliveryAddress(address);
    };

    onEmailChange = (e) => {
        this.props.setEmail(e.target.value);
    }
}

const checkoutStepLoading = createLoadingSelector("CHECKOUT_STEP");

const mapStateToProps = state => {
    const kioskOptions = getKioskOptions(state);
    return {
        deliveryOptions: getAvailableDeliveryOptions(state),
        selectedOption: state.reservation.selected_delivery_option || state.delivery.id,
        deliveryPhone: state.delivery.phone !== false ? state.delivery.phone : state.member.phone,
        countryCode: state.delivery.countryCode,
        isKioskMode: isKioskMode(state),
        kioskCollectCustomerEmail: kioskOptions.collectCustomerEmail,
        kioskPrintsTickets: kioskOptions.printReceiptsAndTickets ? true : false,
        email: state.member.email,
        gatewayType: state.payment.gatewayType,
        address: state.delivery.address !== false ? state.delivery.address : getDefaultAddress(state),
        hasAddress: state.delivery.address !== false,
        loading: checkoutStepLoading(state)
    }
};

const mapDispatchToProps = dispatch => {
    return bindActionCreators({
        setDeliveryMethod,
        setDeliveryPhone,
        setDeliveryAddress,
        setFee: feesSlice.actions.setFee,
        getInsuranceQuote,
        initKeyboard,
        setEmail,
        setDeliveryCountryCode,
    }, dispatch);
};

DeliveryContainer.propTypes = {
    deliveryOptions: PropTypes.arrayOf(Object),
    selectedOption: PropTypes.number
};

export default connect(mapStateToProps, mapDispatchToProps)(DeliveryContainer)
